import React from 'react';
import { connect } from 'react-redux';
import _find from 'lodash/find';
import _findLast from 'lodash/findLast';
import _get from 'lodash/get';
import PropTypes from 'prop-types';
// Custom
import { cpmOperationDataShape, cpmDoorDataShape } from 'constants/PropTypesShapes';
import { ASYNC_OP_STATUS_PENDING } from 'constants/App';
import { TriggerDoorIconButton } from 'components/buttons/IconButtons';
import { TriggerDoorContainedButton } from 'components/buttons/ContainedButtons';

const CarparkDoorTriggerButtonContent = React.memo(({
  type, loading, tooltipValues, onClick,
}) => {
  // Button props
  const buttonProps = {
    loading,
    tooltipValues,
    onClick,
  };

  if (type === 'icon') {
    return (
      <TriggerDoorIconButton primary {...buttonProps} />
    );
  } if (type === 'contained') {
    return (
      <TriggerDoorContainedButton primary {...buttonProps} />
    );
  }
  return null;
});

CarparkDoorTriggerButtonContent.displayName = 'CarparkDoorTriggerButtonContent';

CarparkDoorTriggerButtonContent.propTypes = {
  type: PropTypes.oneOf(['icon', 'contained']).isRequired,
  loading: PropTypes.bool.isRequired,
  tooltipValues: PropTypes.object.isRequired,
  onClick: PropTypes.func.isRequired,
};

const CarparkDoorTriggerButton = ({
  door, type, carparkTrigger, operations, onTrigger,
}) => {
  // Try to find associated operation (carparkTrigger may be null)
  const operation = _find(operations, ['id', _get(carparkTrigger, 'operationId')]);

  // Component props
  const compProps = {
    type,
    loading: _get(operation, 'status') === ASYNC_OP_STATUS_PENDING,
    tooltipValues: { type: door.type },
    onClick: onTrigger,
  };

  return (
    <CarparkDoorTriggerButtonContent {...compProps} />
  );
};

CarparkDoorTriggerButton.propTypes = {
  door: cpmDoorDataShape.isRequired,
  type: PropTypes.oneOf(['icon', 'contained']),
  carparkTrigger: PropTypes.shape({
    resource: PropTypes.shape({
      id: PropTypes.number.isRequired,
      type: PropTypes.string.isRequired,
    }).isRequired,
    operationId: PropTypes.number.isRequired,
  }),
  operations: PropTypes.arrayOf(cpmOperationDataShape).isRequired,
  onTrigger: PropTypes.func.isRequired,
};

CarparkDoorTriggerButton.defaultProps = {
  type: 'icon',
  carparkTrigger: null,
};

const mapStateToProps = (state, ownProps) => ({
  carparkTrigger: _findLast(state.cpmCarparkTrigger.list, (carparkTrigger) => (
    _get(carparkTrigger, 'resource.type') === 'door' && _get(carparkTrigger, 'resource.id') === ownProps.door.id)),
  operations: state.cpmOperation.list,
});

module.exports = connect(
  mapStateToProps,
  null,
)(CarparkDoorTriggerButton);



// WEBPACK FOOTER //
// ./routes/cpm/routes/carparks/assets/main/CarparkDoorTriggerButton.js